import { Tooltip } from 'antd';
import { IoWarningOutline } from 'react-icons/io5';
import { Sim900WaitingActivationStatus } from 'src/shared/enum/sim.enum';

type StatusTagConfig = {
  label: string;
  textClassName: string;
  importantTextClassName: string;
};

const statusConfigs: Record<Sim900WaitingActivationStatus, StatusTagConfig> = {
  [Sim900WaitingActivationStatus.Created]: {
    label: 'Đã tạo',
    textClassName: 'text-[#fa8c16]',
    importantTextClassName: '!text-[#fa8c16]',
  },
  [Sim900WaitingActivationStatus.WaitingActivation900]: {
    label: 'Chờ kích hoạt 900',
    textClassName: 'text-[#722ed1]',
    importantTextClassName: '!text-[#722ed1]',
  },
  [Sim900WaitingActivationStatus.Activated]: {
    label: 'Đã kích hoạt',
    textClassName: 'text-[#52c41a]',
    importantTextClassName: '!text-[#52c41a]',
  },
  [Sim900WaitingActivationStatus.Completed]: {
    label: 'Hoàn thành',
    textClassName: 'text-[#1677ff]',
    importantTextClassName: '!text-[#52c41a]',
  },
  [Sim900WaitingActivationStatus.Canceled]: {
    label: 'Đã hủy',
    textClassName: 'text-[#ff4d4f]',
    importantTextClassName: '!text-[#ff4d4f]',
  },
  [Sim900WaitingActivationStatus.Error]: {
    label: 'Lỗi',
    textClassName: 'text-[#ff4d4f]',
    importantTextClassName: '!text-[#ff4d4f]',
  },
};

const normalizeStatus = (
  status?: Sim900WaitingActivationStatus | number | string,
): Sim900WaitingActivationStatus | undefined => {
  const statusNumber = Number(status);

  if (Number.isNaN(statusNumber)) {
    return undefined;
  }

  return Object.values(Sim900WaitingActivationStatus).includes(statusNumber)
    ? (statusNumber as Sim900WaitingActivationStatus)
    : undefined;
};

export const getSim900StatusTagConfig = (
  status?: Sim900WaitingActivationStatus | number | string,
): StatusTagConfig => {
  const normalizedStatus = normalizeStatus(status);

  return normalizedStatus
    ? statusConfigs[normalizedStatus]
    : {
        label: 'Không xác định',
        textClassName: 'text-[#8c8c8c]',
        importantTextClassName: '!text-[#8c8c8c]',
      };
};

type Sim900StatusTagProps = {
  status?: Sim900WaitingActivationStatus | number | string;
  showWarning?: boolean;
};

export default function Sim900StatusTag({ status, showWarning = true }: Sim900StatusTagProps) {
  const config = getSim900StatusTagConfig(status);

  return (
    <span
      className={`whitespace-nowrap font-semibold flex items-center gap-1 ${config.textClassName}`}
    >
      {config.label}{' '}
      {status === Sim900WaitingActivationStatus.Created && showWarning && (
        <Tooltip title='Thuê bao chưa đủ điều kiện để có thể kích hoạt'>
          <IoWarningOutline className='text-lg' />
        </Tooltip>
      )}
    </span>
  );
}
